export const envUrl = (developmentUrl, prodUrl) => (process.env.NODE_ENV === 'production' ? prodUrl : developmentUrl);
export { scrollIntoView, scrollToSwoosh } from './scroll';
export { handleFocus, setFocus, setBlur } from './accessibility';
export { createToken } from './helpers';
export {
  getStepPath,
  getSteps,
  getStepTitle,
  setMaxCompletedStep,
  getCurrentStepIndex,
  clearMaxCompletedStep,
} from './stepTracker';
